// src/routes/RequiresAuth.jsx
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../context';
import toast from 'react-hot-toast';

const RequiresAuth = () => {
  const { token } = useAuthContext();

  useEffect(() => {
    if (!token) {
      toast.error("Please Login/Sign up");
    }
  }, [token]);

  return token
    ? <Outlet />
    : <Navigate to="/login" replace />;
};

export default RequiresAuth;
